export default "__VITE_ASSET__CEMRBrzv__"